import * as React from "react";
import TopBarProgress from "react-topbar-progress-indicator";

TopBarProgress.config({
  barColors: {
    0: "#fff",
    "1.0": "#fff",
  },
  shadowBlur: 5,
});

const TopBarComponent = () => {
  return (
    <React.Fragment>
      <TopBarProgress />
    </React.Fragment>
  );
};

export default TopBarComponent;
